const _excluded = ["inputService", "label", "optionList", "keyLookup", "itemRender", "itemStyle", "multiSelect", "required", "disabled", "hideLabel", "allowFreeform", "autoComplete", "allowClear", "optionsQuery", "debounceRate", "placeholder", "onValueChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { VirtualizedComboBox } from 'office-ui-fabric-react';
import { useDebounce } from 'react-use';
import { useInput } from '../../../machines/inputMachine/useInput';
import { Label } from '../../Label';
import { Stack } from '../../Stack';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { SharedClearButton } from '../SharedClearButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function VirtualizedComboBoxControl(_ref) {
  let {
      inputService,
      label,
      optionList,
      keyLookup,
      itemRender,
      itemStyle,
      multiSelect = false,
      required = false,
      disabled = false,
      hideLabel = false,
      allowFreeform = true,
      autoComplete = 'on',
      allowClear,
      optionsQuery,
      debounceRate = 200,
      placeholder = '',
      onValueChange
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!inputService) return /*#__PURE__*/_jsx("div", {
    children: "no input service defined"
  });
  const comboBoxRef = React.useRef(null);
  const [inputValue, setInputValue] = React.useState('');
  const {
    name,
    value,
    errorMessage,
    touched,
    send
  } = multiSelect ? useInput(inputService) : useInput(inputService);
  function getOptions() {
    if (!optionList) {
      return [];
    }
    return optionList.map(option => {
      return {
        key: keyLookup(option),
        text: itemRender(option),
        styles: itemStyle ? itemStyle(option) : undefined
      };
    });
  }
  function getSelectedKeys() {
    var _selectedValues$map;
    const selectedValues = value;
    return (_selectedValues$map = selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(item => keyLookup(item))) !== null && _selectedValues$map !== void 0 ? _selectedValues$map : [];
  }
  function getValue(selected) {
    let updatedValue = multiSelect ? [] : '';
    if (selected && optionList) {
      if (multiSelect) {
        const newValue = value ? [...value] : [];
        const foundIndex = newValue.findIndex(v => keyLookup(v) === selected.key);
        if (foundIndex > -1) {
          newValue.splice(foundIndex, 1);
        } else {
          const found = optionList.find(v => keyLookup(v) === selected.key);
          found && newValue.push(found);
        }
        return newValue;
      }
      updatedValue = optionList.find(v => keyLookup(v) === selected.key);
    }
    if (optionsQuery) {
      optionList = [];
      optionsQuery('');
    }
    return updatedValue;
  }
  if (optionsQuery) {
    useDebounce(() => {
      optionsQuery(inputValue);
    }, debounceRate, [inputValue]);
  }
  React.useEffect(() => {
    var _optionList;
    if (optionsQuery && optionList && ((_optionList = optionList) === null || _optionList === void 0 ? void 0 : _optionList.length) > 0 && inputValue.length > 0) {
      var _comboBoxRef$current;
      (_comboBoxRef$current = comboBoxRef.current) === null || _comboBoxRef$current === void 0 || _comboBoxRef$current.focus(true);
    }
  }, [optionList]);
  return /*#__PURE__*/_jsxs(Stack, {
    children: [!hideLabel && /*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      horizontalAlign: "space-between",
      grow: true,
      children: [/*#__PURE__*/_jsx(Stack.Item, {
        align: "start",
        children: /*#__PURE__*/_jsxs(Label, {
          children: [label !== null && label !== void 0 ? label : name, " ", required && /*#__PURE__*/_jsx("span", {
            style: {
              color: 'rgb(164, 38, 44)'
            },
            children: "*"
          })]
        })
      }), allowClear && !disabled && /*#__PURE__*/_jsx(Stack.Item, {
        align: "end",
        children: /*#__PURE__*/_jsx(SharedClearButton, {
          simple: allowClear === 'simple',
          send: send
        })
      })]
    }), /*#__PURE__*/_jsx(VirtualizedComboBox, _objectSpread(_objectSpread({}, props), {}, {
      "data-id": name,
      styles: {
        container: {
          selectors: {
            // Be wary of this styling hack: https://stackoverflow.com/a/60310536/479836
            // In this case, it might be the only way to style this element.
            // This piece of CSS will hide the dropdown arrow, when an async `optionsQuery` is set.
            '& .ms-Button': {
              display: optionsQuery ? "none" : "inline-block"
            }
          }
        }
      },
      placeholder: placeholder,
      componentRef: comboBoxRef,
      selectedKey: multiSelect ? getSelectedKeys() : value ? keyLookup(value) : '',
      multiSelect: multiSelect ? true : undefined,
      options: getOptions(),
      onChange: (_event, selected) => {
        if (optionsQuery) {
          var _comboBoxRef$current2;
          (_comboBoxRef$current2 = comboBoxRef.current) === null || _comboBoxRef$current2 === void 0 || _comboBoxRef$current2.focus(false);
        }
        const newValue = getValue(selected);
        if (onValueChange) onValueChange(newValue);else send([{
          type: 'CHANGE',
          value: newValue
        }, {
          type: 'COMMIT'
        }, {
          type: 'BLUR'
        }]);
      },
      onBlur: () => {
        if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) > 0) {
          setInputValue('');
        }
        send({
          type: 'BLUR'
        });
      },
      onFocus: () => {
        send({
          type: 'FOCUS'
        });
      },
      onKeyUp: e => {
        if (optionsQuery) {
          const target = e.target;
          setInputValue(target.value);
        }
      },
      required: required,
      disabled: disabled,
      allowFreeform: allowFreeform,
      autoComplete: autoComplete
    })), props.customErrorMessage && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: props.customErrorMessage
    }) || errorMessage && touched && errorMessage.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }, "error".concat(index)))]
  });
}